var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"video",attrs:{"id":"video","poster":_vm.poster || _vm.videoImg,"src":_vm.src,"controls":"","controlslist":"nodownload","height":"auto","preload":"metadata","width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }